import { publicApi } from '../lib/api'

export type AppVersionMeta = {
  git_sha: string
  build_time: string
  env: string
}

export async function getAppVersionMeta(): Promise<AppVersionMeta> {
  const { data } = await publicApi.get<AppVersionMeta>('/api/meta/version')
  return data
}

export type TimeZoneMetaRow = {
  name: string
  display_name: string
  aliases?: string[]
  is_common?: boolean
}

export async function listMetaTimezones(params: { q?: string; limit?: number } = {}): Promise<TimeZoneMetaRow[]> {
  const { data } = await publicApi.get<{ results: TimeZoneMetaRow[] }>('/api/meta/timezones/', { params })
  return Array.isArray(data?.results) ? data.results : []
}
